// AddCategoryDialog — Kategorie anlegen: Name eingeben, Enter. Checkbox „Zählt nicht zum
// Deck" legt eine ausgeschlossene Kategorie (Maybeboard) an. Die Kleinschreibung des
// Namens erzwingt das Backend.
import React, { useState, useEffect } from 'react';
import SchemaModal from '../../../ui/SchemaModal';
import Input from '../../../ui/Input';
import Form from '../../../ui/Form';

export default function AddCategoryDialog({ open, onOpenChange, onAdd }) {
  const [name, setName] = useState('');
  const [isExcluded, setIsExcluded] = useState(false);

  useEffect(() => {
    if (open) { setName(''); setIsExcluded(false); }
  }, [open]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    onAdd?.(trimmed, isExcluded);
    onOpenChange?.(false);
  };

  return (
    <SchemaModal
      open={open}
      onOpenChange={onOpenChange}
      size="sm"
      title="Kategorie hinzufügen"
      footer={
        <>
          <button type="button" className="btn-secondary" onClick={() => onOpenChange(false)}>Abbrechen</button>
          <button type="submit" form="add-category-form" className="btn-primary" disabled={!name.trim()}>Hinzufügen</button>
        </>
      }
    >
      <form id="add-category-form" onSubmit={handleSubmit}>
        <Form.Option>
          <input type="checkbox" checked={isExcluded} onChange={(e) => setIsExcluded(e.target.checked)} />
          Zählt nicht zum Deck
        </Form.Option>
        <div style={{ marginTop: '10px' }}>
          <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Name der Kategorie" autoFocus />
        </div>
      </form>
    </SchemaModal>
  );
}
